import React from 'react';
import Route from 'react-router/lib/Route';
import IndexRoute from 'react-router/lib/IndexRoute';
import IndexRedirect from 'react-router/lib/IndexRedirect';
import { paymentProcessingGuard, requireIntegrationPermission } from '../../auth/routerHooks';
import BarberUserSettingsWrapper from '../../barber/wrappers/barberUserSettingsWrapper';
import BarberEditBankAccountContainer from '../../barber/wrappers/barberEditBankAccountContainer';
import ShopUserSettingsWrapper from '../wrappers/shopUserSettingsWrapper';
import ShopEditBankAccountContainer from './bankAccount/shopEditBankAccountContainer';
import BrandUserSettingsWrapper from '../../brand/wrappers/brandUserSettingsWrapper';
import {
  BarberPaymentProcessing,
  BarberPaymentProcessingDashboard,
  ShopPaymentProcessing,
  ShopPaymentProcessingDashboard,
} from './paymentProcessing';
import AddTax from './taxes/Add';
import EditTax from './taxes/Edit';
import AddDiscount from './discounts/containers/Add';
import EditDiscount from './discounts/containers/Edit';
import AddPromoCode from './promoCodes/Add';
import EditPromoCode from './promoCodes/Edit';
import * as hooks from '../../auth/routerHooks';
import { BrandShopifyRoutes, ShopShopifyRoutes } from './integrations/Shopify/routes';
import BrandIntegrations from './integrations/BrandIntegrationsContainer';
import ShopIntegrations from './integrations/ShopIntegrationsContainer';
import { BrandMailchimpRoutes, ShopMailchimpRoutes } from './integrations/Mailchimp/routes';

const ShopRoutes = store => (
  <Route path="/settings" name="settings">
    <IndexRoute
      component={ShopUserSettingsWrapper}
    />
    <Route
      path="bank-account/add"
      name="settings.bank-account.add"
      component={ShopPaymentProcessing}
      onEnter={paymentProcessingGuard(
        store,
        '/settings/payment-processing/add',
        hooks.requireBankAccountModifyPermission
      )}
    >
      <Route
        path="*"
        component={ShopPaymentProcessing}
        onEnter={hooks.requireBankAccountModifyPermission(store)}
      />
    </Route>
    <Route
      path="bank-account/:id/edit(/:editExternal)"
      name="settings.bank-account.edit"
      component={ShopEditBankAccountContainer}
      onEnter={hooks.requireBankAccountModifyPermission(store)}
    />
    <Route
      path="payment-processing"
      name="settings.payment-processing"
      component={ShopPaymentProcessingDashboard}
      onEnter={paymentProcessingGuard(
        store,
        '/settings/bank-account',
        hooks.checkSettingsPermissions
      )}
    >
      <IndexRoute component={ShopPaymentProcessingDashboard} />
      <Route
        path="*"
        component={ShopPaymentProcessingDashboard}
      />
    </Route>
    <Route
      path="bank-account/:id/edit(/:editExternal)"
      name="settings.bank-account.edit"
      component={ShopEditBankAccountContainer}
      onEnter={hooks.requireBankAccountModifyPermission(store)}
    />
    <Route
      path="taxes/add"
      name="settings.taxes.add"
      component={AddTax}
    />
    <Route
      path="taxes/:id/edit"
      name="settings.taxes.edit"
      component={EditTax}
    />
    <Route
      path="discounts/add"
      name="settings.discounts.add"
      component={AddDiscount}
    />
    <Route
      path="discounts/:id/edit"
      name="settings.discounts.edit"
      component={EditDiscount}
    />
    <Route
      path="promo/add"
      name="settings.promoCodes.add"
      component={AddPromoCode}
    />
    <Route
      path="promo/:id/edit"
      name="settings.promoCodes.edit"
      component={EditPromoCode}
    />
    <Route
      component={ShopIntegrations}
      name="settings.integrations"
      path="integrations"
      onEnter={requireIntegrationPermission(store)}
    >
      {ShopShopifyRoutes(store)}
      {ShopMailchimpRoutes(store)}
    </Route>
    <Route
      path=":page"
      component={ShopUserSettingsWrapper}
      name="settings.details"
      onEnter={paymentProcessingGuard(
        store,
        '/settings/payment-processing',
        hooks.checkSettingsPermissions
      )}
    />
  </Route>
);

const BarberRoutes = store => (<Route path="settings" name="settings">
  <Route
    path="taxes/add"
    name="settings.taxes.add"
    component={AddTax}
  />
  <Route
    path="taxes/:id/edit"
    name="settings.taxes.edit"
    component={EditTax}
  />
  <Route
    path="bank-account/:id/edit(/:editExternal)"
    name="settings.bank-account.edit"
    component={BarberEditBankAccountContainer}
  />
  <Route
    path="bank-account/add"
    name="settings.bank-account.add"
    component={BarberPaymentProcessing}
    onEnter={paymentProcessingGuard(
        store,
        '/barber/settings/payment-processing/add'
      )}
  >
    <Route
      path="*"
      component={BarberPaymentProcessing}
    />
  </Route>
  <Route
    path="payment-processing"
    name="settings.payment-processing"
    component={BarberPaymentProcessingDashboard}
    onEnter={paymentProcessingGuard(
        store,
        '/barber/settings/bank-account'
      )}
  >
    <IndexRoute component={BarberPaymentProcessingDashboard} />
    <Route
      path="*"
      component={BarberPaymentProcessingDashboard}
    />
  </Route>
  <Route
    path=":page"
    component={BarberUserSettingsWrapper}
    onEnter={paymentProcessingGuard(
        store,
        '/barber/settings/payment-processing'
      )}
  />
  <Route
    path="discounts/add"
    name="settings.discounts.add"
    component={AddDiscount}
  />
  <Route
    path="discounts/:id/edit"
    name="settings.discounts.edit"
    component={EditDiscount}
  />
  <Route
    path="promo/add"
    name="settings.promoCodes.add"
    component={AddPromoCode}
  />
  <Route
    path="promo/:id/edit"
    name="settings.promoCodes.edit"
    component={EditPromoCode}
  />
</Route>);

const BrandRoutes = store => (
  <Route path="settings" name="settings">
    <IndexRedirect to="details" />
    <Route
      path="taxes/add"
      name="settings.taxes.add"
      component={AddTax}
    />
    <Route
      path="taxes/:id/edit"
      name="settings.taxes.edit"
      component={EditTax}
    />
    <Route
      component={BrandIntegrations}
      path="integrations"
      onEnter={requireIntegrationPermission(store)}
    >
      {BrandShopifyRoutes(store)}
      {BrandMailchimpRoutes(store)}
    </Route>
    <Route path=":page" component={BrandUserSettingsWrapper} />
  </Route>
);

export default {
  ShopRoutes,
  BarberRoutes,
  BrandRoutes,
};
